

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'Home',
  computed: {
    ...mapState('app', ['drawerVisible']),
    ...mapState({
      isHaveReportRight: state => state.isHaveReportRight,
      isHaveReportRightINS: state => state.isHaveReportRightINS,
    })
  },
  methods: {
    ...mapActions('app', ['showOverlay', 'hideOverlay']),
    mobileMenuClick(){
      if(isMobile()){
        this.$store.commit('app/toggleDrawer')
      }
    },

    toggleDrawer() {
    this.$store.commit('app/toggleDrawer')
    },
    
    isMobile(){
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          return true
        } else {
          return false
        }
      }
  },
  data() {
    this.hideOverlay();
    return {
      rapor: ''
    }
  },
};
</script>

<template>
  <div class="">
    <v-layout fill-height row wrap pa-5 justify-space-around v-if="isMobile()">
      Menüye erişebilmek için <v-btn @click="toggleDrawer" style="align-self: right;"> tıklayınız.</v-btn>
     </v-layout>
     <div v-if="isHaveReportRight || isHaveReportRightINS" class="fill-height row wrap pa-5 justify-space-around">
    Raporlara erişebilmek için <v-btn to="/Rapor" style="align-self: right;"> tıklayınız.</v-btn>
  </div>
  </div>
</template>
